import { DepartmentType } from '@app/models/department-type.model';

export const mockOrganisationalUnitTypes: DepartmentType[] = [
  {
    id: 1,
    name: 'Department'
  }
];